import Calendar from "./class/Calendar";

window.customElements.define('calendar-tag', Calendar);
(<HTMLElement>document.querySelector('main')).appendChild(new Calendar());
